import { useState, useEffect, useCallback } from "react";
import type { Period } from "@/types";
import { dbGet, dbSet } from "@/lib/db";
import { SK, currentQuarter } from "@/lib/constants";

export function usePeriod() {
  const [period, setPeriodState] = useState<Period>(currentQuarter);
  const [history, setHistoryState] = useState<Period[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dbGet<Period>(SK.PERIOD),
      dbGet<Period[]>(SK.PERIOD_HISTORY),
    ]).then(([p, h]) => {
      if (p) setPeriodState(p);
      setHistoryState(h ?? []);
      setLoading(false);
    });
  }, []);

  const setPeriod = useCallback(
    (p: Period) => {
      setPeriodState(p);
      dbSet(SK.PERIOD, p);
      const next = [p, ...history.filter(
        (h) => h.start !== p.start || h.end !== p.end
      )].slice(0, 10);
      setHistoryState(next);
      dbSet(SK.PERIOD_HISTORY, next);
    },
    [history]
  );

  const setAllPeriod = useCallback(
    (p: Period, h: Period[]) => {
      setPeriodState(p);
      setHistoryState(h);
      dbSet(SK.PERIOD, p);
      dbSet(SK.PERIOD_HISTORY, h);
    },
    []
  );

  return { period, history, loading, setPeriod, setAllPeriod };
}
